module.exports = __webpack_public_path__ + "static/media/contactsBlack.c6120dde.svg";